import { z } from 'zod';
import { ApiMethod } from '../types/api.types';
import { workspaceParamsSchema } from '../types/payloads/workspace.payload';
import { fileCreateBody } from '../types/payloads/file.payload';
import { assetUploadCompleteBody } from '../types/payloads/asset.payload';
import { fileCreateResponse } from '../types/responses/file.responses';
import { assetSchema } from '../types/asset.types';
import { castPublicViewQuerySchema } from '../types/payloads/cast.payload';

export const API_TOKEN_RECURSIVE_CONTENT = {
    POST: {
        method: ApiMethod.POST,
        path: '/workspaces/:workspaceName/tokens/recursive-content/folders/:folderUuid',
        handlerMethod: 'createRecursiveFolderContentToken',
        zod: {
            params: z.object({
                workspaceName: z.string(),
                folderUuid: z.string().uuid()
            })
        },
        responses: {
            200: {
                description: 'Token created',
                schema: z.object({
                    token: z.string().uuid()
                })
            }
        }
    },
    POST_CAST: {
        method: ApiMethod.POST,
        path: '/tokens/recursive-content/cast/:castUid',
        handlerMethod: 'createRecursiveCastContentToken',
        isPublic: true,
        zod: {
            params: z.object({
                castUid: z.string().min(6).max(6)
            }),
            query: castPublicViewQuerySchema
        },
        responses: {
            200: {
                description: 'Token created',
                schema: z.object({
                    token: z.string().uuid()
                })
            }
        }
    },
    GET: {
        method: ApiMethod.GET,
        path: '/tokens/recursive-content/:token',
        handlerMethod: 'useRecursiveContentToken',
        isPublic: true,
        zod: {
            params: z.object({
                token: z.string().uuid()
            }),
            query: z.object({
                folderUuid: z.string().optional()
            })
        }
    }
} as const;

export const API_TOKEN_PROJECT_DROP_FOLDER = {
    GET: {
        method: ApiMethod.GET,
        path: '/tokens/:token/project-drop-folder/:workspaceName',
        handlerMethod: 'findProjectWithProjectDropFolderToken',
        isPublic: true,
        zod: {
            params: workspaceParamsSchema.extend({
                token: z.string().uuid()
            })
        }
    },
    POST: {
        method: ApiMethod.POST,
        path: '/tokens/:token/project-drop-folder/:workspaceName/asset',
        handlerMethod: 'createFileWithProjectDropFolderToken',
        isPublic: true,
        zod: {
            params: workspaceParamsSchema.extend({
                token: z.string().uuid()
            }),
            body: fileCreateBody
        },
        responses: {
            200: {
                description: '',
                schema: fileCreateResponse
            }
        }
    },
    PUT: {
        method: ApiMethod.PUT,
        path: '/tokens/:token/project-drop-folder/:workspaceName/asset/:assetUuid',
        handlerMethod: 'completeMultipartUploadWithProjectDropFolderToken',
        isPublic: true,
        zod: {
            params: workspaceParamsSchema.extend({
                token: z.string().uuid(),
                assetUuid: z.string().uuid()
            }),
            body: assetUploadCompleteBody
        },
        responses: {
            200: {
                description: 'Asset uploaded',
                schema: assetSchema
            }
        }
    }
} as const;
